if($('.js-pull-section-up').length){

    // Used to add min height to element which matches the width. (creates a square when dynamic content is in use)
    $(window).on('load resize', function () {
        if ($(window).width() >= 993) {
            var $imgBtm = $('.js-pull-section-up img');
            var imgBottom = $imgBtm.position().top + $imgBtm.outerHeight(true);

            var $formBtm = $('.js-get-btm');
            var frmBtm = $formBtm.position().top + $formBtm.outerHeight(true);
            var circleHeight = $('.js-get-btm').outerHeight();

            $('.js-pull-up').each(function () {
                var distance = parseInt(frmBtm) - parseInt(imgBottom) + parseInt('10');	//distance between
                var padBottom = parseInt(circleHeight) + parseInt('10');
                $('.js-pull-up').css('margin-top', '-' + distance + 'px');

                if(!$(this).hasClass('no-js-bottom-padding')) {
                    if ($(window).width() >= 2001) {
                        $('.js-pull-up').css('padding-bottom', '150px');
                    }

                    if ( $(window).width() > 1401 && $(window).width() < 2000) {
                        var newDistance = padBottom / 1.25;
                        console.log(newDistance);
                        $('.js-pull-up').css('padding-bottom', newDistance + 'px');
                    }
                    if ( $(window).width() > 993 && $(window).width() < 1400) {
                        $('.js-pull-up').css('padding-bottom', padBottom + 'px');
                    }
                } else {
                    $('.js-pull-up').css('padding-bottom', '');
                }
            });
        }
    });
}else{

}
